import { render, staticRenderFns } from "./BlockAdminSidebar.vue?vue&type=template&id=2ab7fd14&scoped=true&"
import script from "./BlockAdminSidebar.vue?vue&type=script&lang=js&"
export * from "./BlockAdminSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BlockAdminSidebar.vue?vue&type=style&index=0&id=2ab7fd14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab7fd14",
  null
  
)

export default component.exports